import { withStyles } from "@material-ui/core/styles";
import FilterSort from "./FilterSort";
import styles from "./styles";

export default withStyles(styles)(FilterSort);
